export var RequestExpand = /*#__PURE__*/function (RequestExpand) {
  RequestExpand["CONTENT"] = "content.body";
  RequestExpand["NONE"] = "none";
  return RequestExpand;
}({});